<!--  -->
<template>
    <div class="bod">
    <Breadcrumb style="margin-top: 20px;margin-left: 163px;margin-bottom: 20px;color: rgb(110, 114, 117);">
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem to="/message">相关资讯</BreadcrumbItem>
        <BreadcrumbItem>详情</BreadcrumbItem>
    </Breadcrumb>
      <div class="flex">
        <div style="width: 900px;" class="biaoti">
            朝九晚四灵活用工进园区公益活动--走进莱迪创新科技园
        </div>
      </div>
      <div class="flex">
      <div class="xgleft3"></div>
        <div class="xgleft4">就业创业</div>
        <div class="xgleft1">发布时间：&nbsp&nbsp2022.05.16</div>
      </div>
      <div class="flex">
        <div class="wenben1">
            上周，朝九晚四巾帼创客中心为继续推动育儿妈妈灵活就业，充分发挥女性能顶“半边天”的重要作用，走进广州莱迪创新科技园区，与其负责人共同探讨园区内的朝九晚四灵活就业岗位开发主题。
        </div>
      </div>
      <div class="flex">
        <div class="page7tu1"></div>
      </div>
      <div class="flex">
        <div style="margin-bottom: 50px;" class="wenben2">       园区负责人深知目前就业形势及国家大力推动灵活就业用工方式，必竭力践行社会责任，将进一步关注了解育儿妈妈朝九晚四灵活就业，为育儿妈妈量身定做更多“上班近，下班早，顾家赚钱兼顾好” 的岗位！</div>
      </div>
      <div class="flex">
        <div style="margin-bottom: 20px;" class="page7tu2"></div>
      </div>
      <div class="flex">
        <hr class="hr1"/>
      </div>
      <div style="margin-left: 163px;float: left;">
        <div class="next">上一篇</div>
        <div class="nextkuang">
          <div class="xgleft1">2022.08.23</div>
          <router-link to="/page6" class="text1">【公益创投 暖席广州】朝九晚四“三步学会电商直播”主题培训</router-link>
          <div class="xgleft3"></div>
          <div class="xgleft4">就业创业</div>
          <router-link to="/page6" class="text2">为了充分发挥妇女能顶半边天的作用，结合灵活就业的大趋势，盘活乡村妇女劳动力， 2022年8月23日上午，第九届广州市社会组织公益创投活动“乡村振兴，社企共建——困境妇女直播技能......</router-link>
          <router-link to="/page6"><div class="text3">查看详情<img src="../../../assets/images/you.png"></div></router-link>
        </div>
      </div>
      <div style="margin-left: 75px;float: left;">
        <div class="next">下一篇</div>
        <div class="nextkuang">
          <div class="xgleft1">2022.05.10</div>
          <router-link to="/page8" class="text1">广州火炬高新技术创业服务中心参观朝九晚四巾帼创客中心</router-link>
          <div class="xgleft3"></div>
          <div class="xgleft4">各界关怀</div>
          <router-link to="/page8" class="text2">5月9日下午，广州火炬高新技术创业服务中心企业服务部杨乐怡、广州开发区科技企业孵化器协会秘书长王天宜、工作人员严雪婧前来朝九晚四巾帼创客中心走访参观......</router-link>
          <router-link to="/page8"><div class="text3">查看详情<img src="../../../assets/images/you.png"></div></router-link>
        </div>
      </div>
      <div class="clean"></div>
    </div>
  
  </template>
  
  <script>
  export default {
    data() {
      return {
  
      }
    },
    methods: {
  
    },
    created() {
  
    }
  }
  </script>
  
  <style lang="less" scoped>
  @import "./page.less";
  </style>
  